module.exports = __webpack_public_path__ + "static/img/bg6.2894e43.svg";